
import TextBlock from '../implementations/Block/TextBlock';
import CtaBlock from '../implementations/Block/CtaBlock';

const mappers = {
  basic: TextBlock,
  cta_block: CtaBlock,
};

export default mappers;

